import { FaChevronDown } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { memo, useState } from 'react';
import FlightSeatMapModal from './FlightSeatMapModal';

const FlightsSeatMap = ({ flights }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleViewSeatmapClick = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <button type="button" onClick={handleViewSeatmapClick} className="inline-block text-center ml-5">
        View Seat Availability
        <FaChevronDown className="inline-block ml-1" />
      </button>
      {isModalOpen && (
        <FlightSeatMapModal flights={flights} onModalClose={handleModalClose} canPickSeat={false} />
      )}
    </>
  );
};

FlightsSeatMap.propTypes = {
  flights: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default memo(FlightsSeatMap);
